import React, { Component } from 'react';
import './Rating.css';

export default class Rating extends Component {
    renderRating(rating) {
        const stars = [];
        let i;

        for (i = 0; i < rating; i++) {
            stars.push(<span key={ 'star' + i } id={'star_' + i}>★</span>);
        }
        return stars;
    }

    render() {
        const rating = Math.round(this.props.avgRating);

        return (
            <div className={ this.props.className + (rating < 4 ? ' low-rating' : '') }>
                { this.renderRating(rating) }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/Statistics/Rating/index.js